export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_07-f7af08c3780c2cbf2ae896bbfbc95fc5.jpg";